import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=0eda0635&"
import script from "./Chatroom.vue?vue&type=script&lang=js&"
export * from "./Chatroom.vue?vue&type=script&lang=js&"
import style0 from "./Chatroom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports